

export enum IbUiTimerTemplateType { hourAndMinutes = 'type-1', clockType = 'type-2', fullDate = 'type-3'}